import React from 'react';

/**
 * Google Material Symbols (Outlined), weight 400 — Clinical Curator / stitch 规范.
 * @see https://fonts.google.com/icons
 */
export function LimsNavIcon({
  name,
  className,
  style,
  sizePx = 22
}: {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  sizePx?: number;
}) {
  return (
    <span
      className={`material-symbols-outlined lims-ms-icon ${className || ''}`}
      style={{ fontSize: sizePx, ...style }}
      aria-hidden
    >
      {name}
    </span>
  );
}
